import { Component, OnInit, Input } from '@angular/core';
import { UtilService } from '../../../../shared/services';

@Component({
  selector: 'app-team',
  templateUrl: './team.component.html',
  styleUrls: ['./team.component.scss']
})
export class TeamComponent implements OnInit {

  @Input() public team;
  @Input() public rewards;
  @Input() public isFundraiserEnded;
  @Input() public sharedCounts;

  constructor(
    public utilService: UtilService
  ) { }

  ngOnInit() {
  }
  checkLength(arr) {
    return arr && arr.length ? true : false;
  }
  /**Get the class of the social icon
   * @param name  Name of the social site
   */
  getClass(name) {
    switch (name) {
      case 'facebook':
        return 'icon-fb i-fb';
      case 'twitter':
        return 'icon-twitter i-tweet';
      case 'linkedin':
        return 'icon-linkedin i-link';
      default:
        return '';
    }
  }

}
